import { defineMosaicComponent } from "@/components/Mosaic/defineMosaicComponent";

import type CaseSearchBase from "@/pages/CaseSearch.Base.vue";

export default defineMosaicComponent<typeof CaseSearchBase>("pages/CaseSearch");
